export type VehicleSeriesDefinition = {
  /**
   * Series definition id
   */
  id: string;
  /**
   * Definition name
   */
  name: string;
  /**
   * ID of existed series
   */
  seriesId: string;
  /**
   * ID of existed Branch. If is not provided then definition is valid for whole Tenant
   */
  branchId: string | null;
  vehicleType: string | null;
  /**
   * To which makes will be definition applied
   */
  makes: Array<string> | null;
  /**
   * System definition are unable to be deleted and editing is limited
   */
  isSystem: boolean;
};
